<template>
  <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center">Resource Master</h1>
    <div class="form shadow p-4 mb-5 bg-white rounded no-margin-rows">
      <div class="row">
        <div class="col">
          <label for="brandBox">Brand</label>
          <input
              id="brandBox"
              v-model="brandName"
              type="text"
              class="form-control"
              readonly
          />
        </div>
        <div class="col">
          <label for="resourceTypeBox">Resource type</label>
          <input
              id="resourceTypeBox"
              v-model="resourceType"
              type="text"
              class="form-control"
              readonly
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label for="storeCodeBox">Store code</label>
          <input
              id="storeCodeBox"
              v-model="storeCode"
              type="text"
              class="form-control"
              readonly
          />
        </div>
        <div class="col">
          <label for="storeNameBox">Store name</label>
          <input
              id="storeNameBox"
              v-model="storeName"
              type="text"
              class="form-control"
              readonly
          />
        </div>
      </div>
      <v-tabs v-model="activeTab" class="custom-tabs">
        <v-tab>Details</v-tab>
        <v-tab v-if="isRoomResource">Day offs</v-tab>
      </v-tabs>
      <div>
        <v-tabs-items v-model="activeTab" class="overflow-visible">
          <v-tab-item class="tab-content">
            <div class="pt-4 align-items-center">
              <div class="mb-6">
                <strong>General</strong>
                <div class="row">
                  <div class="col-6">
                    <label for="nameBox">Name</label>
                    <input
                        id="nameBox"
                        v-model="form.name"
                        type="text"
                        class="form-control"
                    />
                    <div v-if="isSubmit && error.errorName" class="text-error">
                      {{ error.errorName.message }}
                    </div>
                  </div>
                  <div v-if="resourceTypeEnum === 'STAFF'" class="col-6">
                    <label for="staffCodeBox"
                    >Staff code<span class="required">*</span></label
                    >
                    <input
                        id="staffCodeBox"
                        v-model="form.staffCode"
                        type="text"
                        class="form-control"
                    />
                    <div
                        v-if="isSubmit && error.errorStaffCode"
                        class="text-error"
                    >
                      {{ error.errorStaffCode.message }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <input
                        id="isActiveBox"
                        type="checkbox"
                        v-model="form.status"
                        class="form-check-input mr-2"
                    />
                    <label class="form-check-label" for="isActiveBox">
                      Active
                    </label>
                    <div
                        v-if="isSubmit && error.errorStatus"
                        class="text-error"
                    >
                      {{ error.errorStatus.message }}
                    </div>
                  </div>
                  <div class="col-4">
                    <label for="startDatePicker"
                    >Start date<span class="required">*</span></label
                    >
                    <div class="d-flex align-items-center">
                      <DatePicker
                          id="startDatePicker"
                          v-bind="$attrs"
                          v-model="form.startDate"
                          format="DD/MM/yyyy"
                          lang="en"
                          :value="form.startDate"
                          @change="
                          changeStartDate($event);
                          form.startDate = $event;
                        "
                          style="margin-top: -0.6rem"
                      />
                      <button
                          type="button"
                          @click="form.startDate = null"
                          class="btn btn-outline-secondary ml-1"
                          style="height: calc(100%); white-space: nowrap"
                      >
                        Clear
                      </button>
                    </div>
                    <div
                        v-if="isSubmit && error.errorStartDate"
                        class="text-error"
                    >
                      {{ error.errorStartDate.message }}
                    </div>
                  </div>
                  <div class="col-4">
                    <label for="endDatePicker">End date</label>
                    <div class="d-flex align-items-center">
                      <DatePicker
                          id="endDatePicker"
                          v-bind="$attrs"
                          v-model="form.endDate"
                          format="DD/MM/yyyy"
                          lang="en"
                          @change="
                          changeEndDate($event);
                          form.endDate = $event;
                        "
                          :value="form.endDate"
                          :minDate="form.startDate"
                          style="margin-top: -0.6rem"
                      />
                      <button
                          type="button"
                          @click="form.endDate = null"
                          class="btn btn-outline-secondary ml-1"
                          style="height: calc(100%); white-space: nowrap"
                      >
                        Clear
                      </button>
                    </div>
                    <div
                        v-if="isSubmit && error.errorEndDate"
                        class="text-error"
                    >
                      {{ error.errorEndDate.message }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-6">
                <strong>Services</strong>
                <div
                    v-if="isSubmit && error.errorServiceIds"
                    class="text-error"
                >
                  {{ error.errorServiceIds.message }}
                </div>
                <div class="row">
                  <div class="col-3">
                    <input
                        type="checkbox"
                        id="selectAllCheckbox"
                        :checked="isAllChecked"
                        class="form-check-input mr-2"
                        @change="toggleSelectAll($event)"
                    />
                    <label class="form-check-label" for="selectAllCheckbox">
                      Select all
                    </label>
                  </div>
                </div>

                <div class="row">
                  <div
                      v-for="(service, index) in serviceList"
                      :key="index"
                      class="col-6 align-items-center"
                  >
                    <input
                        type="checkbox"
                        :id="'checkbox-' + index"
                        v-model="service.isChecked"
                        class="form-check-input mr-2"
                        @change="updateSelectAllState"
                    />
                    <label class="form-check-label" :for="'checkbox-' + index">
                      {{ service.nameTh }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="mb-6">
                <div v-if="isRoomResource">
                  <div>
                    <strong>Service time</strong>
                  </div>
                  <div class="row font-weight-bold">
                    <div class="col-2 d-flex align-items-center">
                      <input
                          type="checkbox"
                          class="form-check-input mr-2"
                          id="select-all-days"
                          :checked="areAllDaysChecked"
                          @change="toggleAllDays($event.target.checked)"
                      />
                      <label class="form-check-label mb-0" for="select-all-days">
                        Select All
                      </label>
                    </div>
                    <div class="col-4 d-flex align-items-center">Start Time</div>
                    <div class="col-4 d-flex align-items-center">End Time</div>
                  </div>
                  <div
                      class="row"
                      v-for="(day, index) in form.workDays"
                      :key="index"
                      @change="handleDayToggle(day)"
                  >
                    <div class="col-2">
                      <input
                          type="checkbox"
                          v-model="day.isChecked"
                          class="form-check-input mr-2"
                      />
                      {{ day.name }}
                      <div
                          v-if="error.errorWorkDays && error.errorWorkDays[day.dayOfWeek] && error.errorWorkDays[day.dayOfWeek].checkbox"
                          class="text-error"
                      >
                        {{ error.errorWorkDays[day.dayOfWeek].checkbox.message }}
                      </div>
                    </div>
                    <div class="col-4">
                      <TimePicker
                          :id="'startTimePicker-' + index"
                          v-model="day.startTime"
                          label="กรุณาเลือกเวลา"
                          format="24hr"
                          :allowed-minutes="[0, 15, 30, 45]"
                          :disabled="!day.isChecked"
                          style="margin-top: -1rem"
                      />
                      <div
                          v-if="error.errorWorkDays && error.errorWorkDays[day.dayOfWeek] && error.errorWorkDays[day.dayOfWeek].startTime"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorWorkDays[day.dayOfWeek].startTime.message }}
                      </div>
                    </div>
                    <div class="col-4">
                      <TimePicker
                          :id="'endTimePicker-' + index"
                          v-model="day.endTime"
                          label="กรุณาเลือกเวลา"
                          format="24hr"
                          :allowed-minutes="[0, 15, 30, 45]"
                          :disabled="!day.isChecked"
                          style="margin-top: -1rem"
                      />
                      <div
                          v-if="error.errorWorkDays && error.errorWorkDays[day.dayOfWeek] && error.errorWorkDays[day.dayOfWeek].endTime"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorWorkDays[day.dayOfWeek].endTime.message }}
                      </div>
                    </div>
                    <div class="col-2" v-if="index === 0">
                      <button
                          class="btn btn-outline-primary btn-sm"
                          @click="applyAllDays"
                          :disabled="
                          !day.isChecked || !day.startTime || !day.endTime
                        "
                      >
                        Apply All
                      </button>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center flex-wrap gap-3" v-if="showShiftSection">
                  <div>
                    <strong>Service time</strong>
                  </div>
                  <button class="btn btn-primary text-white" @click="openModal">
                    Manage Staff Shifts
                  </button>
                </div>
                <div>

                  <div class="row">
                    <div class="col-6">
                      <div
                          class="d-flex align-items-center justify-content-start"
                      >
                        <span>
                          <strong>Date created: </strong> &nbsp;
                          {{ dateCreated }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div
                          class="d-flex align-items-center justify-content-start"
                      >
                        <span>
                          <strong>Last updated: </strong> &nbsp;
                          {{ lastUpdated }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button
                        class="btn btn-outline-success ml-10"
                        @click="onSubmit('main')"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item v-if="id && isRoomResource" class="tab-content day-off-tab">
            <div style="overflow: visible; position: relative;">
              <ListDayOff
                  :key="activeTab"
                  :resource-id="this.id"
                  :store-code="this.storeCode"
                  :resource-type="this.resourceTypeEnum"
              />
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-primary text-white" @click="$router.go(-1)">
          Back
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="row text-center">
          <div v-if="showSuccess && storeCode" class="col-12">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="col-12">
            <button
                class="btn-back"
                @click="
                () =>
                  $router.push({
                    name: 'CounterService',
                  })
              "
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
        </div>
        <div v-if="!showSuccess" class="row text-center">
          <div class="col">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-if="showShiftSection" v-model="showServiceTimeDialog" width="800" persistent>
      <v-card class="content-dialog pa-4" height="80%">
        <div class="d-flex justify-content-between mb-2">
          <div class="pt-2">
            <strong>Service time</strong>
          </div>
          <v-btn icon @click="showServiceTimeDialog = false">
            <font-awesome-icon :icon="['fas','times']" class="close-icon"/>
          </v-btn>
        </div>
        <div v-if="shiftValidationError" class="alert alert-danger mb-3">
          {{ shiftValidationError }}
        </div>
        <div class="col-4">
          <label for="monthYear">เดือน</label>
          <template>
            <v-menu
                v-model="isMonthMenuOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="selectedMonthText"
                    :readonly="true"
                    label="Select Month"
                    v-bind="attrs"
                    v-on="on"
                >
                  <template #prepend-inner>
                    <font-awesome-icon :icon="['fas','calendar-alt']" class="mr-2"/>
                  </template>
                </v-text-field>
              </template>

              <v-date-picker
                  v-model="selectedMonth"
                  type="month"
                  color="primary"
                  @input="handleMonthSelect"
                  :min="minDate"
              />
            </v-menu>

          </template>

        </div>
        <div>
          <div class="row font-weight-bold align-items-center">
            <div class="col-4 d-flex align-items-center">
              <input
                  type="checkbox"
                  class="form-check-input mr-2"
                  v-model="selectAllDatesChecked"
                  @change="toggleSelectAllDates"
                  :disabled="!hasShiftAssignments"
              />
              <span>Date</span>
            </div>
            <div class="col-2"></div>
            <div class="col-4">เวลาทำงาน</div>
          </div>

          <div
              class="row"
              v-for="(day, index) in datesInMonth"
              :key="day.date"
          >
            <div class="col-4">
              <input
                  type="checkbox"
                  v-model="day.isChecked"
                  class="form-check-input mr-2"
                  @change="handleDayToggle(day)"
                  :disabled="!hasShiftAssignments"
              />
              {{ day.date }}
              <div
                  v-if="getCheckboxErrorForDate(day.date)"
                  class="text-error"
              >
                {{ getCheckboxErrorForDate(day.date).message }}
              </div>
            </div>
            <div class="col-2">
              {{ day.day }}
            </div>
            <div class="col-4">
              <div class="d-flex align-items-center">
                <multiselect
                    :id="'shifts-'+index"
                    :ref="`shiftSel-${index}`"
                    v-model="day.selectedShift"
                    :options="shiftOptions"
                    label="label"
                    track-by="value"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :searchable="false"
                    placeholder="เลือกชิฟต์"
                    :disabled="!day.isChecked || !hasShiftAssignments"
                    @input="onShiftSelect(day)"
                    :class="{'border border-danger rounded': missingShiftDates.includes(day.date)}"
                />
                <button
                    class="btn btn-sm btn-outline-primary ml-2"
                    @click="applyShiftToAll(day)"
                    :disabled="!day.isChecked || !day.selectedShift || !hasShiftAssignments"
                    title="ใช้ชิฟต์นี้กับทุกวันที่ติ๊กไว้"
                >
                  Apply All
                </button>
              </div>
              <div
                  v-if="getShiftDropdownErrorForDate(day.date)"
                  class="text-error"
              >
                {{ getShiftDropdownErrorForDate(day.date).message }}
              </div>
            </div>

          </div>

          <div class="d-flex justify-content-end mt-5">
            <button
              class="btn btn-outline-secondary btn-cancel"
              @click="showServiceTimeDialog = false"
            >
              Close
            </button>
            <button
                class="btn btn-outline-success ml-5"
                @click="onSaveShift"
            >
              Save
            </button>
          </div>
        </div>

      </v-card>
    </v-dialog>
    <v-dialog v-model="showConfirmChangeMonth" width="520" persistent>
      <v-card class="pa-5">
        <div class="mb-3">
          <h3 class="mb-2">ต้องการเปลี่ยน เดือน/ปี?</h3>
          <p class="mb-0">
            ข้อมูลที่ได้แก้ไขยังไม่ได้ถูกบันทึก การเปลี่ยนเดือน/ปีขณะนี้ จะส่งผลให้การแก้ไขข้อมูลไม่ถูกจัดเก็บ
          </p>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <v-btn variant="outlined" class="mr-2" @click="cancelChangeMonth">
            ยกเลิก
          </v-btn>

          <v-btn color="primary" class="text-white" @click="confirmChangeMonth">
            ตกลง
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <CustomConfirmDialog
      v-model="isShowConfirmSaveShiftDialog"
      :message=confirmSaveShiftMessage
      confirmButtonLabel="ตกลง"
      cancelButtonLabel="ยกเลิก"
      @confirm="onSubmit('shift')"
      :width = 520
    />
  </div>

</template>

<script>
import DatePicker from "components/Datepicker/Datepicker.vue";
import ServiceMasterService from "services/api/serviceMaster.service";
import ResourceMasterService from "services/api/resourceMaster.service";
import moment from "moment/moment";
import ListDayOff from "@/views/Store/CounterService/ListDayOff.vue";
import TimePicker from "components/Timepicker/TimePicker.vue";
import Multiselect from "vue-multiselect";
import CustomConfirmDialog from "components/Dialog/CustomConfirmDialog.vue";

export default {
  components: { CustomConfirmDialog, TimePicker, ListDayOff, DatePicker, Multiselect},
  data() {
    return {
      id: this.$route.query.id,
      isLoading: false,
      isSubmit: false,
      message: null,
      showDialog: false,
      showSuccess: false,
      isShowConfirmSaveShiftDialog: false,
      confirmSaveShiftMessage: 'การเปลี่ยนเวลาบริการจะถูกบันทึกไว้ในประวัติการแก้ไขของระบบ และจะมีผลกับเวลาที่ลูกค้าสามารถจองได้ ยืนยันที่จะบันทึกการเปลี่ยนแปลงนี้หรือไม่',
      resourceTypeEnum: this.$route.query.resourceType,
      resourceType: this.leadWithUpperCase(this.$route.query.resourceType),
      brandCode: null,
      brandName: null,
      storeCode: null,
      storeName: null,
      activeTab: 0,
      serviceList: [],
      dateCreated: null,
      lastUpdated: null,
      selectedTime: null,
      form: {
        name: null,
        staffCode: null,
        status: false,
        startDate: null,
        endDate: null,
        shiftAssignments: [],
        originalShiftAssignments: [],
        workDays: [
          {
            isChecked: false,
            name: "Mon",
            dayOfWeek: 1,
            startTime: "",
            endTime: "",
          },
          {
            isChecked: false,
            name: "Tue",
            dayOfWeek: 2,
            startTime: "",
            endTime: "",
          },
          {
            isChecked: false,
            name: "Wed",
            dayOfWeek: 3,
            startTime: "",
            endTime: "",
          },
          {
            isChecked: false,
            name: "Thu",
            dayOfWeek: 4,
            startTime: "",
            endTime: "",
          },
          {
            isChecked: false,
            name: "Fri",
            dayOfWeek: 5,
            startTime: "",
            endTime: "",
          },
          {
            isChecked: false,
            name: "Sat",
            dayOfWeek: 6,
            startTime: "",
            endTime: "",
          },
          {
            isChecked: false,
            name: "Sun",
            dayOfWeek: 7,
            startTime: "",
            endTime: "",
          },
          {
            isChecked: false,
            name: "Public Holiday",
            dayOfWeek: 0,
            startTime: "",
            endTime: "",
          },
        ],
      },
      error: {
        errorName: "",
        errorStaffCode: "",
        errorStatus: "",
        errorStartDate: "",
        errorEndDate: "",
        errorServiceIds: "",
        errorWorkDays: {},
        errorShiftAssignments: "",
      },
      shiftOptions: [
        {value: "A", label: "Shift A"},
        {value: "B", label: "Shift B"},
        {value: "AB", label: "Shift AB"},
      ],
      showServiceTimeDialog: false,
      isMonthMenuOpen: false,
      selectedMonth: "",
      selectedMonthText: "",
      minDate: null,
      datesInMonth: [],
      justCreated: false,
      _reopenAfterDialog: false,
      hasUnsavedShiftChanges: false,
      pendingMonthValue: null,
      showConfirmChangeMonth: false,
      selectAllDatesChecked: false,
      shiftValidationError: "",
      missingShiftDates: [],
    };
  },
  async mounted() {
    const details = sessionStorage.getItem("storeDetails");
    if (details) {
      const parsedDetails = JSON.parse(details);
      this.brandCode = parsedDetails.brandCode;
      this.brandName = parsedDetails.brandName;
      this.storeCode = parsedDetails.storeCode;
      this.storeName = parsedDetails.displayName ?? parsedDetails.name;

      await this.getServices();

      if (this.id) {
        this.isLoading = true;
        if (this.resourceTypeEnum === "ROOM") {
          await this.getRoomDetail();
        } else if (this.resourceTypeEnum === "STAFF") {
          await this.getStaffDetail();
        } else {
          await this.$router.push({name: "CounterService"});
        }
      }
    } else {
      await this.$router.push({name: "StoreMaster"});
    }
    this.selectedMonth = moment().format("YYYY-MM");
    this.selectedMonthText = moment().format("YYYY/MM");
    this.datesInMonth = this.generateDatesInMonth(this.selectedMonth);
  },
  methods: {
    onSubmit(source) {
      this.isSubmit = true;
      this.isLoading = true;
      this.showSuccess = false;
      this.resetErrorText();
      this.shiftValidationError = "";
      this.missingShiftDates = [];

      let body;

      const isRoom  = this.resourceTypeEnum === "ROOM";
      const isStaff = this.resourceTypeEnum === "STAFF";
      if (!isRoom && !isStaff) {
        this.$router.push({ name: "CounterService" });
        return;
      }

      const buildRoomBody = () => ({
        name: this.form.name,
        status: this.form.status ? "ACTIVE" : "INACTIVE",
        startDate: this.convertToISO8601(this.form.startDate),
        endDate: this.convertToISO8601(this.form.endDate),
        serviceIds: this.serviceList.filter(s => s.isChecked).map(s => s.id),
        workDays: this.form.workDays
            .filter(day => day.isChecked)
            .map(day => ({
              dayOfWeek: day.dayOfWeek,
              startTime: day.startTime,
              endTime: day.endTime,
            })),
      });

      const buildStaffBase = () => {
        const { year, month } = this.getYearMonthFromSelected();
        return {
          name: this.form.name,
          staffCode: this.form.staffCode,
          status: this.form.status ? "ACTIVE" : "INACTIVE",
          startDate: this.convertToISO8601(this.form.startDate),
          endDate: this.convertToISO8601(this.form.endDate),
          serviceIds: this.serviceList.filter(s => s.isChecked).map(s => s.id),
          year, month,
        };
      };

      const getAssignments = () => (
          source === "shift"
              ? this.datesInMonth
                  .filter(d => d.isChecked && d.selectedShift)
                  .map(d => ({
                    date: d.date,
                    dayType: this.getDayType(d.date),
                    shifts: this.collapseShift(d.selectedShift.value),
                  }))
              : this.form.shiftAssignments.map(d => ({
                date: d.date,
                dayType: d.dayType,
                shifts: d.shifts,
              }))
      );

      body = isRoom
          ? buildRoomBody()
          : { ...buildStaffBase(), shiftAssignments: getAssignments() };

      const action = this.id ? "update" : "create";
      this[`${action}${isRoom ? "Room" : "Staff"}`](body);
    },

    async getServices() {
      const params = this.getParams();
      await ServiceMasterService.getListServiceMaster(params)
          .then((res) => {
            this.serviceList = res.data.services;
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
    },
    async getRoomDetail() {
      const opts = this.getYearMonthFromSelected();
      await ResourceMasterService.getDetailRoom(this.storeCode, this.id, opts)
          .then((res) => {
            this.getDetailSuccess(res);
          })
          .catch((err) => {
            this.requestFailure(err);
          });
    },
    async getStaffDetail() {
      const opts = this.getYearMonthFromSelected();
      await ResourceMasterService.getDetailStaff(this.storeCode, this.id, opts)
          .then((res) => {
            this.getDetailSuccess(res);
          })
          .catch((err) => {
            this.requestFailure(err);
          });
    },
    async createRoom(body) {
      try {
        await ResourceMasterService.createRoom(this.storeCode, body).then(
            (res) => {
              this.createUpdateSuccess(res);
            }
        );
      } catch (error) {
        this.requestFailure(error);
      }
    },
    async createStaff(body) {
      try {
        await ResourceMasterService.createStaff(this.storeCode, body).then(
            (res) => {
              this.createUpdateSuccess(res);
            }
        );
      } catch (error) {
        this.requestFailure(error);
      }
    },
    async updateRoom(body) {
      try {
        await ResourceMasterService.updateRoom(
            this.storeCode,
            this.id,
            body
        ).then((res) => {
          this.createUpdateSuccess(res);
        });
      } catch (error) {
        this.requestFailure(error);
      }
    },
    async updateStaff(body) {
      try {
        await ResourceMasterService.updateStaff(
            this.storeCode,
            this.id,
            body
        ).then((res) => {
          this.createUpdateSuccess(res);
        });
      } catch (error) {
        this.requestFailure(error);
      }
    },
    getDetailSuccess(result) {
      this.isLoading = false;
      const data = result.data;

      this.form.name = data.name;
      this.form.staffCode = data.staffCode;
      this.form.status = data.status === "ACTIVE";
      this.form.startDate = this.toBangkokDateTime(data.startDate, "YYYY-MM-DD");
      this.form.endDate = this.toBangkokDateTime(data.endDate, "YYYY-MM-DD");
      this.form.serviceIds = data.serviceIds;
      this.form.shiftAssignments = Array.isArray(data.shiftAssignments) ? data.shiftAssignments : [];
      this.form.originalShiftAssignments = this.form.shiftAssignments;

      this.form.workDays = this.form.workDays.map((day) => {
        const correspondingDay = data.workDays.find(
            (workDay) => workDay.dayOfWeek === day.dayOfWeek
        );

        return {
          ...day,
          isChecked: !!correspondingDay,
          startTime: correspondingDay ? correspondingDay.startTime : "",
          endTime: correspondingDay ? correspondingDay.endTime : "",
        };
      });
      this.prefillShiftsFromApi(this.form.shiftAssignments);

      this.serviceList = this.serviceList.map(s => ({...s, isChecked: data.serviceIds.includes(s.id)}));
      this.dateCreated = this.toBangkokDateTime(data.dateCreated, "DD/MM/YYYY HH:mm:ss");
      this.lastUpdated = this.toBangkokDateTime(data.lastUpdated, "DD/MM/YYYY HH:mm:ss");
    },

    createUpdateSuccess(result) {
      this.isLoading = false;

      const data = result.data;
      this.message = data.message || "บันทึกสำเร็จ";

      this.showServiceTimeDialog = false;

      this.showSuccess = true;
      this.showDialog = true;

      this._reopenAfterDialog = false;

      this.id = data.id;
      this.$router.replace({query: {...this.$route.query, id: data.id}});

      if (data.dateCreated) {
        this.dateCreated = this.toBangkokDateTime(data.dateCreated, "DD/MM/YYYY HH:mm:ss");
      }
      if (data.lastUpdated) {
        this.lastUpdated = this.toBangkokDateTime(data.lastUpdated, "DD/MM/YYYY HH:mm:ss");
      }

      this.isSubmit = false;
      this.hasUnsavedShiftChanges = false;
    },
    toggleSelectAll(event) {
      const isChecked = event.target.checked;
      this.serviceList = this.serviceList.map((service) => ({
        ...service,
        isChecked: isChecked,
      }));
    },
    updateSelectAllState() {
      const totalCheckboxes = this.serviceList.length;
      const checkedCount = this.serviceList.filter(
          (service) => service.isChecked
      ).length;

      this.isAllChecked =
          totalCheckboxes > 0 && checkedCount === totalCheckboxes;
    },
    getParams() {
      return {
        brandCode: this.brandCode,
        status: "ACTIVE",
      };
    },
    async setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    leadWithUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    changeStartDate(val) {
      if (val > this.form.endDate) {
        this.form.endDate = null;
      }
    },
    changeEndDate(event) {
      this.form.endDate = event?.target?.value || null;
    },

    toBangkokDateTime(date, format) {
      if (!date) return null;
      return moment(date).utcOffset("+07:00").format(format);
    },
    convertToISO8601(date) {
      if (!date) return null;
      return moment(date, "YYYY-MM-DD").toISOString();
    },

    dateKeyFromAssignment(a) {
      return typeof a?.date === 'string'
          ? moment(a.date).format('YYYY-MM-DD')
          : this.toIsoDateFromJavaDate(a?.date);
    },

    createAssignment(date, selectedOrCode) {
      const code = typeof selectedOrCode === 'string'
          ? selectedOrCode
          : selectedOrCode?.value;
      return {
        date,
        dayType: this.getDayType(date),
        shifts: code ? this.collapseShift(code) : [],
      };
    },

    requestFailure(err) {
      this.isLoading = false;
      this._reopenAfterDialog = !!this.showServiceTimeDialog;
      this.showServiceTimeDialog = false;
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        this.setErrorText(errorData.errors);
      }
      if (errorData.message) {
        this.message = errorData.message;
      } else {
        this.message = "ไม่สามารถบันทึกได้";
      }
      this.showDialog = true;
    },
    setErrorText(errors) {
      this.error.errorName = errors.find((e) => e.fieldName === "name");
      this.error.errorStaffCode = errors.find(
          (e) => e.fieldName === "staffCode"
      );
      this.error.errorStatus = errors.find((e) => e.fieldName === "status");
      this.error.errorStartDate = errors.find(
          (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorServiceIds = errors.find(
          (e) => e.fieldName === "serviceIds"
      );
      this.error.errorShiftAssignments = errors.filter((e) => e.fieldName?.includes("shiftAssignments"));

      const dayMap = {
        'MONDAY': 1,
        'TUESDAY': 2,
        'WEDNESDAY': 3,
        'THURSDAY': 4,
        'FRIDAY': 5,
        'SATURDAY': 6,
        'SUNDAY': 7,
        'PUBLIC_HOLIDAY': 0
      };
      this.error.errorWorkDays = {};
      errors.forEach((e) => {
        if (e.fieldName.startsWith("workDays.")) {
          const parts = e.fieldName.replace("workDays.", "").split(".");
          const dayName = parts[0];
          const dayOfWeek = dayMap[dayName];

          if (dayOfWeek !== undefined) {
            if (!this.error.errorWorkDays[dayOfWeek]) {
              this.error.errorWorkDays[dayOfWeek] = {};
            }

            const field = parts.length === 1 ? 'checkbox' : parts[1];
            this.error.errorWorkDays[dayOfWeek][field] = e;
          }
        }
      });
    },
    resetErrorText() {
      this.error = {
        errorName: "",
        errorStaffCode: "",
        errorStatus: "",
        errorStartDate: "",
        errorEndDate: "",
        errorServiceIds: "",
        errorShiftAssignments: "",
        errorWorkDays: {},
      };
    },
    applyAllDays() {
      const mondaySettings = this.form.workDays[0];

      if (
          !mondaySettings.isChecked ||
          !mondaySettings.startTime ||
          !mondaySettings.endTime
      ) {
        return;
      }

      for (const day of this.form.workDays) {
        if (day.isChecked) {
          this.$set(day, "startTime", mondaySettings.startTime);
          this.$set(day, "endTime", mondaySettings.endTime);
        }
      }
    },
    openModal() {
      if (!this.showShiftSection) return;
      this.selectedMonth = moment().format("YYYY-MM");
      this.selectedMonthText = moment(this.selectedMonth, "YYYY-MM").format("YYYY/MM");
      this.datesInMonth = this.generateDatesInMonth(this.selectedMonth);
      this.showServiceTimeDialog = true;
      this.hasUnsavedShiftChanges = false;
      this.selectAllDatesChecked = false;
      this.fetchDetailForSelectedMonth();
    },


    generateDatesInMonth(monthStr) {
      const startOfMonth = moment(monthStr, "YYYY-MM").startOf("month");
      const endOfMonth = moment(monthStr, "YYYY-MM").endOf("month");

      const dates = [];
      let currentDate = startOfMonth.clone();
      while (currentDate.isSameOrBefore(endOfMonth, "day")) {
        dates.push({
          date: currentDate.format("YYYY-MM-DD"),
          day: currentDate.format("ddd"),
          isChecked: false,
          selectedShift: null,
        });
        currentDate.add(1, "day");
      }
      return dates;
    },

    handleDayToggle(day) {
      if (day.isChecked) {
        const others = (this.form.shiftAssignments || []).filter(a => this.dateKeyFromAssignment(a) !== day.date);
        this.form.shiftAssignments = [...others, this.createAssignment(day.date, day.selectedShift)];
      } else {
        day.selectedShift = null;

        this.form.shiftAssignments = (this.form.shiftAssignments || [])
            .filter(a => this.dateKeyFromAssignment(a) !== day.date);
      }

      this.hasUnsavedShiftChanges = true;
      this.syncSelectAllCheckbox();

      if (!this.datesInMonth.some(d => d.isChecked && !d.selectedShift)) {
        this.shiftValidationError = "";
        this.missingShiftDates = [];
      }
    },



    handleMonthSelect(value) {
      const ym = typeof value === "string" ? value : moment(value).format("YYYY-MM");

      if (this.hasUnsavedShiftChanges) {
        this.pendingMonthValue = ym;
        this.showConfirmChangeMonth = true;
        return;
      }

      this.applyMonthChange(ym);
    },

    getDayType(dateStr) {
      const n = moment(dateStr, "YYYY-MM-DD").isoWeekday();
      const names = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
      return names[n - 1];
    },

    getYearMonthFromSelected() {
      const yearMonth = String(this.selectedMonth || "").trim();
      if (!yearMonth) return {};
      const [y, m] = yearMonth.split("-").map(n => Number.parseInt(n, 10));
      if (!Number.isInteger(y) || !Number.isInteger(m)) return {};
      return {year: y, month: m};
    },

    async fetchDetailForSelectedMonth() {
      if (!this.id || this.resourceTypeEnum !== "STAFF") return;
      const opts = this.getYearMonthFromSelected();
      try {
        const res = await ResourceMasterService.getDetailStaff(this.storeCode, this.id, opts);
        this.getDetailSuccess(res);
      } catch (err) {
        this.requestFailure(err);
      }
    },

    toIsoDateFromJavaDate(javaDate) {
      if (!javaDate) return null;
      const y = javaDate.year;
      const m = javaDate.monthValue ?? this.monthNameToNum(javaDate.month?.name);
      const d = javaDate.dayOfMonth;
      if (!y || !m || !d) return null;
      return moment({year: y, month: m - 1, day: d}).format("YYYY-MM-DD");
    },
    monthNameToNum(name) {
      if (!name) return null;
      const idx = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"].indexOf(String(name).toUpperCase());
      return idx === -1 ? null : idx + 1;
    },

    prefillShiftsFromApi(assignments) {
      if (!Array.isArray(assignments)) return;

      const byDate = new Map();

      assignments.forEach(a => {
        const dateStr = typeof a?.date === 'string'
            ? moment(a.date).format('YYYY-MM-DD')
            : this.toIsoDateFromJavaDate(a?.date);

        const code = this.expandFromArray(a?.shifts);

        if (dateStr && code) byDate.set(dateStr, code);
      });

      this.datesInMonth = this.datesInMonth.map(d => {
        const code = byDate.get(d.date);
        if (!code) return d;
        const opt = this.shiftOptions.find(o => o.value === code) || null;
        return {
          ...d,
          isChecked: true,
          selectedShift: opt,
        };
      });
      this.selectAllDatesChecked = false;
    },

    collapseShift(code) {
      return code === 'AB' ? ['A', 'B'] : [code];
    },

    expandFromArray(arr) {
      if (!Array.isArray(arr) || arr.length === 0) return null;
      const s = new Set(arr);
      if (s.has('A') && s.has('B')) return 'AB';
      if (s.has('A')) return 'A';
      if (s.has('B')) return 'B';
      return null;
    },
    markShiftDirty() {
      this.hasUnsavedShiftChanges = true;
    },
    applyMonthChange(ym) {
      this.selectedMonth = ym;
      this.selectedMonthText = moment(ym, "YYYY-MM").format("YYYY/MM");
      this.datesInMonth = this.generateDatesInMonth(ym);
      this.isMonthMenuOpen = false;
      this.fetchDetailForSelectedMonth();
      this.selectAllDatesChecked = false;
    },
    toggleAllDays(checked) {
      this.form.workDays.forEach(day => {
        day.isChecked = checked;
      });
    },
    toggleSelectAllDates() {
      const checked = this.selectAllDatesChecked;

      if (checked) {
        this.datesInMonth = this.datesInMonth.map(d => ({
          ...d,
          isChecked: true,
        }));

        const monthDates = new Set(this.datesInMonth.map(d => d.date));
        const keepOld = (this.form.shiftAssignments || [])
               .filter(a => !monthDates.has(this.dateKeyFromAssignment(a)));

        const addThisMonth = this.datesInMonth.map(d => this.createAssignment(d.date, d.selectedShift));

        this.form.shiftAssignments = [...keepOld, ...addThisMonth];

        this.hasUnsavedShiftChanges = true;
      } else {
        this.datesInMonth = this.datesInMonth.map(d => ({
          ...d,
          isChecked: false,
          selectedShift: null,
        }));

        const month = this.selectedMonth;
        this.form.shiftAssignments = (this.form.shiftAssignments || [])
             .filter(a => !this.dateKeyFromAssignment(a).startsWith(month + '-'));

        this.hasUnsavedShiftChanges = true;
      }
    },

    syncSelectAllCheckbox() {
      this.selectAllDatesChecked =
          this.datesInMonth.length > 0 &&
          this.datesInMonth.every(d => d.isChecked);
    },

    onShiftSelect(day) {
      const others = (this.form.shiftAssignments || []).filter(a => this.dateKeyFromAssignment(a) !== day.date);
      const entry = this.createAssignment(day.date, day.selectedShift);

      this.form.shiftAssignments = [...others, entry];
      this.hasUnsavedShiftChanges = true;

      if (day.selectedShift) {
        this.missingShiftDates = this.missingShiftDates.filter(d => d !== day.date);
        if (this.missingShiftDates.length === 0) {
          this.shiftValidationError = "";
        }
      }

      if (!this.datesInMonth.some(d => d.isChecked && !d.selectedShift)) {
        this.shiftValidationError = "";
        this.missingShiftDates = [];
      }
    },

    onSaveShift(event) {
      const focusFirstMissing = (missing) => {
        const firstDate  = missing[0].date;
        const firstIndex = this.datesInMonth.findIndex(d => d.date === firstDate);
        const refKey     = `shiftSel-${firstIndex}`;
        this.$nextTick(() => {
          let ref = this.$refs[refKey];
          if (Array.isArray(ref)) ref = ref[0];
          if (ref?.activate) ref.activate();
          else if (ref?.$el) (ref.$el.querySelector("input") || ref.$el).focus();
        });
      };

      const missing = this.datesInMonth.filter(d => d.isChecked && !d.selectedShift);
      if (missing.length) {
        this.isLoading = false;
        this.missingShiftDates = missing.map(d => d.date);
        this.shiftValidationError = "กรุณาเลือกชิฟต์ให้ครบทุกวันที่เลือกไว้ก่อนบันทึก";
        focusFirstMissing(missing);
        return;
      } else{
        this.isShowConfirmSaveShiftDialog = true;
      }

      event.target.value = "";
    },

    applyShiftToAll(day) {
      if (!day?.selectedShift || !day.isChecked) return;

      const sel = day.selectedShift;

      this.datesInMonth = this.datesInMonth.map(d => {
        if (!d.isChecked) return d;
        return { ...d, selectedShift: sel };
      });

      const checkedDates = new Set(
          this.datesInMonth.filter(d => d.isChecked).map(d => d.date)
      );

      const others = (this.form.shiftAssignments || [])
             .filter(a => !checkedDates.has(this.dateKeyFromAssignment(a)));

      const add = this.datesInMonth
             .filter(d => d.isChecked)
         .map(d => this.createAssignment(d.date, sel.value));

      this.form.shiftAssignments = [...others, ...add];

      this.missingShiftDates = this.datesInMonth
          .filter(d => d.isChecked && !d.selectedShift)
          .map(d => d.date);

      if (this.missingShiftDates.length === 0) {
        this.shiftValidationError = "";
      }

      this.hasUnsavedShiftChanges = true;
    },

    cancelChangeMonth() {
      this.showConfirmChangeMonth = false;
      this.pendingMonthValue = null;
      this.isMonthMenuOpen = true;
    },

    confirmChangeMonth() {
      this.hasUnsavedShiftChanges = false;
      const ym = this.pendingMonthValue;
      this.showConfirmChangeMonth = false;
      this.pendingMonthValue = null;
      this.applyMonthChange(ym);
    },
    getShiftErrorByPattern(date, suffix = '') {
      if (!this.error.errorShiftAssignments || this.error.errorShiftAssignments.length === 0) return null;

      const exactPattern = `shiftAssignments.${date}${suffix}`;

      const matchingError = this.error.errorShiftAssignments.find(err => {
        return err.fieldName === exactPattern;
      });

      return matchingError || null;
    },
    getCheckboxErrorForDate(date) {
      return this.getShiftErrorByPattern(date);
    },
    getShiftDropdownErrorForDate(date) {
      return this.getShiftErrorByPattern(date, '.shifts');
    },
  },
  computed: {
    isAllChecked() {
      return (
          this.serviceList.length > 0 &&
          this.serviceList.every((service) => service.isChecked)
      );
    },
    areAllDaysChecked() {
      return this.form.workDays.length > 0 &&
          this.form.workDays.every(day => day.isChecked);
    },
    showShiftSection() {
      return this.resourceTypeEnum === "STAFF" && this.id && !this.justCreated;
    },
    isRoomResource() {
      return this.resourceTypeEnum === "ROOM";
    },
    hasShiftAssignments() {
      return Array.isArray(this.form.originalShiftAssignments) && this.form.originalShiftAssignments.length > 0;
    },
  },
  watch: {
    showDialog(val) {
      if (val) {
        if (!this.showSuccess) {
          this._reopenAfterDialog = this._reopenAfterDialog || !!this.showServiceTimeDialog;
        }
        this.showServiceTimeDialog = false;
      } else {
        if (this._reopenAfterDialog && !this.showSuccess) {
          this.showServiceTimeDialog = true;
        }
        this._reopenAfterDialog = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-tabs {
  background-color: whitesmoke;
}

.custom-tabs .v-tab--active {
  background-color: #ffffff;
  color: #000000;
}

.custom-tabs .v-tab {
  background-color: whitesmoke;
  color: black;
}

.custom-tabs .v-tab:hover {
  background-color: #a1a1a1;
}

.tab-content {
  padding: 1rem 2rem;
  background-color: whitesmoke;
  color: #000000;
}

.day-off-tab {
  min-height: 500px;
  height: auto;
}

.alert { font-size: 14px; }
</style>
